var map = {
	"./Aceptic HC.jpg": 4940,
	"./Aceptic LA.jpg": 514,
	"./Baccirub Plus.jpg": 4866,
	"./Baccirub.jpg": 4578,
	"./Baccishield.jpg": 7352,
	"./Bacillo Floor.jpg": 3620,
	"./Bacillocid Extra.jpg": 490,
	"./Bacillocil Special.jpg": 7198,
	"./Bacto 256.jpg": 9631,
	"./Bacto Prep.jpg": 8759,
	"./Bacto Scrub.jpg": 7390,
	"./Bactorub Blue.jpg": 8107,
	"./Bactorub.jpg": 3996,
	"./Bacttol 25.jpg": 158,
	"./Baktolin 5.5.jpg": 2278,
	"./Bodedex Forte Cleaner.jpg": 7466,
	"./Cutasept F.jpg": 497,
	"./Cutasept.jpg": 7221,
	"./Despensing Stand-3.jpg": 1933,
	"./Despensing Stand-4.jpg": 3584,
	"./Despensing Stand.jpg": 6416,
	"./Gluthiya OPA.jpg": 8308,
	"./Glutihyde 2 and 2.45.jpg": 5545,
	"./Halothane.jpg": 3400,
	"./Isoflurane.jpg": 1067,
	"./Korsole Rapid 500ml.jpg": 2559,
	"./Linotox.jpg": 1797,
	"./Mikrobac Forte.jpg": 2551,
	"./Ramadine.jpg": 4108,
	"./Sevoflurane.jpg": 3391,
	"./Sojourn.jpg": 3612,
	"./Sokrena.jpg": 1206,
	"./Stelligel Sponge.jpg": 5555,
	"./Sterillium Gel 250 100ml.jpg": 4803,
	"./Sterillium.jpg": 9661,
	"./Wettask wipes with Bacillol25.jpg": 9190,
	"./korso-plus.jpg": 4022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1208;